import React, { useEffect, useRef } from 'react';
import { personalInfo } from '../../data/portfolioData';
import './Hero.css';

const Hero = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationId;
    let stars = [];

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const createStar = () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height * 0.5,
      len: Math.random() * 80 + 40,
      speed: Math.random() * 1 + 0.4,
      opacity: Math.random() * 0.6 + 0.2,
      angle: Math.PI / 4,
    });

    for (let i = 0; i < 3; i++) stars.push(createStar());

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      stars.forEach((star, i) => {
        ctx.save();
        ctx.globalAlpha = star.opacity;
        const gradient = ctx.createLinearGradient(
          star.x, star.y,
          star.x - Math.cos(star.angle) * star.len,
          star.y - Math.sin(star.angle) * star.len
        );
        gradient.addColorStop(0, 'rgba(6, 182, 212, 0.9)');
        gradient.addColorStop(1, 'rgba(6, 182, 212, 0)');
        ctx.strokeStyle = gradient;
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.moveTo(star.x, star.y);
        ctx.lineTo(
          star.x - Math.cos(star.angle) * star.len,
          star.y - Math.sin(star.angle) * star.len
        );
        ctx.stroke();
        ctx.restore();

        star.x += Math.cos(star.angle) * star.speed;
        star.y += Math.sin(star.angle) * star.speed;

        if (star.x > canvas.width + 100 || star.y > canvas.height * 0.6) {
          stars[i] = {
            ...createStar(),
            x: Math.random() * canvas.width * 0.5,
            y: -20,
          };
        }
      });

      animationId = requestAnimationFrame(draw);
    };

    draw();

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  const particles = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    size: Math.random() * 4 + 2,
    delay: `${Math.random() * 10}s`,
    duration: `${Math.random() * 10 + 10}s`,
    color: i % 3 === 0 ? 'var(--color-accent)' : i % 3 === 1 ? '#8b5cf6' : '#06b6d4',
  }));

  return (
    <section className="hero" id="about">
      <canvas ref={canvasRef} className="hero-canvas" />

      <div className="hero-orbs">
        <div className="orb orb-1" />
        <div className="orb orb-2" />
        <div className="orb orb-3" />
      </div>

      <div className="hero-grid" />
      <div className="glow-ring" />

      <div className="particles">
        {particles.map((p) => (
          <div
            key={p.id}
            className="particle"
            style={{
              left: p.left,
              top: p.top,
              width: `${p.size}px`,
              height: `${p.size}px`,
              background: p.color,
              animationDelay: p.delay,
              animationDuration: p.duration,
            }}
          />
        ))}
      </div>

      <div className="hero-content">
        <p className="hero-greeting">{personalInfo.greeting}</p>
        <h1 className="hero-title">{personalInfo.name}</h1>
        <h2 className="hero-subtitle">{personalInfo.title}</h2>
        <p className="hero-description">{personalInfo.description}</p>
        <div className="cta-buttons">
          <a
            href="#contact"
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Get In Touch
          </a>
          <a
            href="#experience"
            className="btn btn-secondary"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('experience')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            View My Work
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
